import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { createAnnonce } from "../../actions/annonce.action";
import { GrUserWorker } from "react-icons/gr";
import { toast, ToastContainer } from "react-toastify";
import PaiementModal from "./AnnoncesInformations";
import { CATEGORIES } from "../categorie.constant";

const TravailForm = ({ utilisateurId }) => {
  const TRAVAIL_CATEGORIE_ID = CATEGORIES.find(cat => cat.label === "Travail")?.id;

  const dispatch = useDispatch();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    setModalIsOpen(true); 
  }, []);

  const [formData, setFormData] = useState({
    titre: "",
    description: "",
    prix: "",
    frequenceSalaire: "",
    secteur: "",
    ville: "",
    contrat: "",
    duree: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = { ...prev, [name]: value };
      return updated;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    const dataToSend = new FormData();
    dataToSend.append("categorieId", TRAVAIL_CATEGORIE_ID);
    dataToSend.append("utilisateur", utilisateurId);
    Object.keys(formData).forEach((key) => {
      dataToSend.append(key, formData[key]);
    });

    try {
      const response = await dispatch(createAnnonce(dataToSend));

      if (
        response &&
        typeof response === "object" &&
        Object.keys(response.errors || {}).length > 0
      ) {
        console.log("Erreurs reçues :", response.errors);
        setErrors(response.errors);
      } else {
        setFormData({
          titre: "",
          description: "",
          prix: "",
          frequenceSalaire: "",
          secteur: "",
          ville: "",
          contrat: "",
          duree: "",
        });

        setErrors({});
        toast.success(
          "Félicitations, votre annonce a bien été créée ! Elle sera soumise à la validation de l'administrateur."
        );
      }
    } catch (err) {
      console.error("Erreur lors de la soumission du formulaire :", err);
    }
  };

  return (
    <>
      <form className="AnnonceForm" onSubmit={handleSubmit}>
        <GrUserWorker />
        <h2>Créer une annonce pour un travail :</h2>

        {errors.titre && (
          <span className="error">Votre annonce doit avoir un titre</span>
        )}
        <input
          type="text"
          name="titre"
          placeholder="Titre"
          onChange={handleChange}
          value={formData.titre}
        />
        {errors.description && (
          <span className="error">
            Veuillez donner une description pour votre annonce
          </span>
        )}
        <textarea
          name="description"
          placeholder="Description"
          onChange={handleChange}
          value={formData.description}
        />

        <div className="priceDiv">
          <input
            type="number"
            name="prix"
            placeholder="Prix"
            onChange={handleChange}
            value={formData.prix}
          />
          <select
            className="frequenceSelect"
            name="frequenceSalaire"
            onChange={handleChange}
            value={formData.frequenceSalaire}
          >
            <option value="">Périodicité</option>
            <option value="Jour">Jour</option>
            <option value="Semaine">Semaine</option>
            <option value="Mois">Mois</option>
          </select>
          <label>FCFA</label>
        </div>

        <input
          type="text"
          name="ville"
          placeholder="Ville"
          onChange={handleChange}
          value={formData.ville}
        />

        {errors.contrat && (
          <span className="error">Veuillez renseigner le type de contrat</span>
        )}
        <select name="contrat" onChange={handleChange} value={formData.contrat}>
          <option value="">Type de contrat</option>
          <option value="CDI">CDI</option>
          <option value="CDD">CDD</option>
          <option value="Intérim">Intérim</option>
          <option value="Mission">Mission</option>
          <option value="Autre">Autre</option>
        </select>

        <input
          type="text"
          name="duree"
          placeholder="Durée du contrat"
          onChange={handleChange}
          value={formData.duree}
        />

        <select name="secteur" onChange={handleChange} value={formData.secteur}>
          <option value="">Secteur d'activité</option>
             <option value="Agricole">Agricole</option>
          <option value="Automobile">Automobile</option>
          <option value="Construction">Bâtiment</option>
          <option value="Commerce">Commerce</option>
          <option value="Santé">Santé</option>
          <option value="Restauration/Hôtellerie">
            Restauration/Hôtellerie
          </option>
          <option value="Services">Services</option>
          <option value="Coiffeur">Coiffeur</option>
          <option value="Esthétique">Esthétique</option>
          <option value="Autre">Autre</option>
        </select>

        <button className="button" type="submit">
          Créer l'annonce
        </button>
                <span>Prix de l'annonce : 1000 Francs CFA</span>
        <span>Paiement par Orange Money au 07-04-64-27-18</span>
      </form>
      <PaiementModal
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
      />
      <ToastContainer position="top-right" autoClose={5000} />
    </>
  );
};

export default TravailForm;
